/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import ReCAPTCHA from "react-google-recaptcha"
import {Typography, Card, CardMedia, CardContent, TextField, Button, CardActions, Divider, CardHeader, Box, Checkbox, InputAdornment, MenuItem } from '@mui/material'
import { LoadingOverlay } from '../components/common'
import styled from 'styled-components'
import BackgroundImage from '../assets/images/background.jpg'
import RegisterBackground from '../assets/images/register.jpg'
import { toast } from 'react-toastify'
import { AppContext } from '../stores/AppStore'
import { UserContext } from '../stores/UserStore'
import flags from '../assets/jsons/flags.json'

const Background = styled.div`
  background: url(${BackgroundImage}) no-repeat center center fixed;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background };
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  overflow: auto;
`
const ContentText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.gray};
  text-align: justify;
  width: 100%;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 
  & .MuiFormControl-root {
    padding: 5px;
  }
`

const Register = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const recaptchaRef = React.useRef()
  const { logo } = useContext(AppContext)    
  const { createUser, app, loadApp, applications, requestAccess } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState(false)
  const [captChar, setCaptChar] = useState(null)
  const [requestUser, setRequestUser] = useState()

  const [record, setRecord] = useState({})

  const handleInputChange = (event) => {
    const data = {...record}
    data[event.target.name] = event.target.value 
    setRecord(data)
  }

  const handleAcceptTermsChange = (event) => {
    const data = {...record}
    data.accept_terms = event.target.checked 
    setRecord(data)
  }

  useEffect(() => {
    if (applications) {
      loadApp().then().catch(error => {
        history.replace('/select-app')
      })
    } 
  }, [applications])     

  const onCaptcharChange = (value) => {
    setCaptChar(value)  
  }

  const onCaptcharExpired = () => {
    setCaptChar(null)
  }

  const onSignInClick = () => {
    const flag = flags.find(x => x.code === record.phone_code)
      
    if (record.email !== record.confirm_email) {
      setCaptChar(null)
      recaptchaRef.current.reset()
      toast.error('Email / Confirm Email do not match.')
      return
    }
    setIsLoading(true)  

    const data = {
      "email": record.email,
      "type": "other",
      "phoneNumber": record.phone,
      "language": "en",
      "location": flag ? flag.country : '', //record.company_country,
      "company": record.company,
      "profiles": [app.id + "_GUEST"],
      "groups": [],
      "name": record.first_name + ' ' + record.last_name,
      "firstName": record.first_name,
      "lastName": record.last_name,
      "address": record.address,
      "position": record.job,
      "zipCode": record.zip_code,
      "city":  record.city,
      "countryCode":record.phone_code,
      "country":  flag ? flag.country : ''// record.country
    }

    createUser(data, captChar).then(() => {
      toast.success('Thank you for registering. You will receive an email to verify your account. Our team will then process with the approval. This process may take 24 hours.')
      setIsLoading(false)
      history.replace('/login?app='+app.id)
    }).catch(errorMessage => {
      setCaptChar(null)
      recaptchaRef.current.reset()
      setIsLoading(false)
      if (errorMessage.indexOf('USER_ALREADY_EXISTS::') !== -1) {
        setRequestUser(errorMessage.replace('USER_ALREADY_EXISTS::', ''))
      } else if (errorMessage === 'USER_ALREADY_EXISTS_AND_REQUESTED') {
          toast.error('Your account is under approval process. Please try again later.')
      } else {
        toast.error(errorMessage)
      }
    })     
  }

  const onGoToLogin = () => {
    setIsLoading(true)
    history.replace('/logout?app='+app.id)
  }

  const onConfirm = () => {
    setIsLoading(true)
    const data = {userId: requestUser, applicationId: app.id} 
    requestAccess(data, captChar).then(() => {
      toast.success('User request success! An email has been sent to ' + app.label + ' to accept your request.')
      // setIsLoading(false)
      history.replace('/logout?app='+app.id)
    }).catch(errorMessage => {
      setCaptChar(null)
      recaptchaRef.current.reset()
      setIsLoading(false)
      console.error(errorMessage)
      if (errorMessage === 'INVALID_CAPTCHAR') {
        toast.error('Invalid CAPTCHAR! Please try again.')
      } else {
        toast.error(errorMessage)
      }
    })        
  }

  const renderBackground = useMemo(() => <>
    { !requestUser ? 
      <Card sx={{width: '80vw', maxHeight: '90vh', display: 'flex', flexDirection: 'column', alignItems: 'stretch', justifyContent: 'stretch', flex: '1 0' }}>
          <CardHeader sx={{flex: '6vh 0'}} avatar={ <img src={logo} style={{height: '5vh'}} alt="logo" /> } title={<Typography variant="h5" color="textSecondary" component="h2">{t('signup-title')}</Typography>} />        
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'stretch', justifyContent: 'stretch', flex: '1 0' }}>
            <CardContent sx={{ flex: '1 0', maxHeight: 'auto', overflow: 'auto' }}> 
              <Row>
                <TextField id="first_name" name="first_name" label={t('mkp-register.first-name-label')} value={record.first_name} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange}  error={record.first_name !== undefined && !record.first_name} />
                <TextField id="last_name" name="last_name" label={t('mkp-register.last-name-label')} value={record.last_name} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange}  error={record.last_name !== undefined && !record.last_name} />
              </Row>
              <Row>
                <TextField id="email" name="email" type="email" label={t('mkp-register.email-label')} value={record.email} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange}  error={(record.email !== undefined && !record.email) || (record.email !== undefined && record.confirm_email !== undefined && record.email !== record.confirm_email)} />
                <TextField id="confirm_email" name="confirm_email" type="email" label={t('mkp-register.confirm-email-label')} value={record.confirm_email} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange}  error={(record.confirm_email !== undefined && !record.confirm_email) || (record.email !== undefined && record.confirm_email !== undefined && record.email !== record.confirm_email)} />
              </Row>
              <Row>
                <TextField id="company" name="company" label={t('mkp-register.company-label')} value={record.company} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange}  error={record.company !== undefined && !record.company} />
                {/* <TextField id="company_country" name="company_country" label={t('mkp-register.country-company-label')} value={record.company_country} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange}  error={record.company_country !== undefined && !record.company_country} /> */}
                <TextField id="job" name="job" label={t('mkp-register.job-label')} value={record.job} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange}  error={record.job !== undefined && !record.job} />
              </Row>
              <Row>
                <TextField id="address" name="address" label={t('mkp-register.address-label')} value={record.address} fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange} />
              </Row>
              <Row>
                <TextField id="zip_code" name="zip_code" label={t('mkp-register.zip-code-label')} value={record.zip_code} fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange} />
                <TextField id="city" name="city" label={t('mkp-register.city-label')} value={record.city} fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange} />
                {/* <TextField id="country" name="country" label={t('mkp-register.country-label')} value={record.country} fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange} /> */}
              </Row>
              <Row>
                <TextField select id="phone_code" name="phone_code" label={t('mkp-register.country-label')} value={record.phone_code} fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange} 
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              { record.phone_code && flags.find(x => x.code === record.phone_code) && <img src={flags.find(x => x.code === record.phone_code).src} alt="Flag Selected" width="36" height="36" /> }
                            </InputAdornment>
                          )                                    
                    }}>
                        { 
                            flags.map((flag) => (
                                <MenuItem key={flag.code} value={flag.code}>
                                    {flag.country}                                                
                                </MenuItem>
                            ))
                        }
                </TextField>
                <TextField id="phone" name="phone" label={t('mkp-register.phone-label')} value={record.phone} fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={handleInputChange} />
              </Row>
              <Row style={{justifyContent: 'space-between', alignItems: 'center', height: '12vh'}}>
                <Row style={{alignItems: 'center'}}>
                  <Checkbox id="accept_terms" name="accept_terms" color="secondary" checked={record.accept_terms === undefined ? false : record.accept_terms} onChange={handleAcceptTermsChange} />
                  <span style={{fontSize: '1vw'}}>{t('mkp-register.conditions')}</span>
                  <Button size="small" href="#" sx={{marginTop: '5px', fontSize: '0.8vw'}}>{t('mkp-register.terms')}</Button>
                </Row>
                <ReCAPTCHA ref={recaptchaRef} hl="en" sitekey={process.env.REACT_APP_CAPTCHAR_SITE_KEY} onChange={onCaptcharChange} onExpired={onCaptcharExpired} />
              </Row>
              <Divider light sx={{ width: '100%'}} />   
              <Row style={{justifyContent: 'center'}}>
                <Button disabled={!record.first_name || !record.last_name || !record.email || !record.confirm_email || !record.company || !record.job || !record.accept_terms || !captChar} variant="contained" onClick={onSignInClick} sx={{width: '200px'}}>{t('mkp-register.signup-button-label')}</Button>
              </Row>
            </CardContent>
            <Box sx={{ flex: '30vw 0', alignItems: 'stretch', justifyContent: 'stretch' }}>
              <CardMedia  sx={{ flex: '1 0'}} component="img" image={RegisterBackground} alt="Logo"/> 
            </Box>
          </Box>       
      </Card>
      :
      <Card sx={{ width:'40vw', height:'50vh', padding:'10px', display: 'flex', flexDirection: 'column', justifyContent:'stretch', alignItems:'stretch' }}>
        <CardContent>
          <Typography variant="h5" color="textSecondary" component="h2" sx={{ marginBottom: '5vh'}}>User already exists!</Typography>
          <ContentText>
            <p> There is already an user with this email registered on the {process.env.REACT_APP_NAME} platform but this user is not linked to the <b>{app && app.label}</b> application!</p>
            <p> Do you want to request access for this application? </p>
          </ContentText>
        </CardContent>
        <CardContent sx={{ height: '15vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <ReCAPTCHA ref={recaptchaRef} hl="en" sitekey={process.env.REACT_APP_CAPTCHAR_SITE_KEY} onChange={onCaptcharChange} onExpired={onCaptcharExpired} />     
        </CardContent>
        <Divider light sx={{ width: '100%'}} /> 
        <CardActions sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', justifyContent: 'space-between' }}> 
          <Button width="140px" onClick={onGoToLogin} >Go to Login</Button>
          <Button width="140px" variant="contained" onClick={onConfirm} disabled={!captChar || !requestUser}>Send Request</Button>
        </CardActions>
      </Card>
    }
    <LoadingOverlay visible={isLoading}/>  
    </>, [requestUser, captChar, record, isLoading, recaptchaRef])     


  return (<Background>  
    { renderBackground } 
  </Background>)
}

export default Register